var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.614 12.706h-6.912v6.912h-1.386v-6.912h-6.93v-1.368h6.93V4.39h1.386v6.948h6.912v1.368Z",
    fill: "#000"
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOS42MTQgMTIuNzA2MUgxMi43MDJWMTkuNjE4MUgxMS4zMTZWMTIuNzA2MUg0LjM4NTk5VjExLjMzODFIMTEuMzE2VjQuMzkwMTRIMTIuNzAyVjExLjMzODFIMTkuNjE0VjEyLjcwNjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";